import { FC, useCallback } from 'react';
import { useField, useForm } from 'react-final-form';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { removeBuilding } from 'src/store/buildings/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { AdministratorBuildingFields } from '../AdministratorBuildingForm/AdministratorBuildingFields';
import { AdministratorBuildingForm } from '../AdministratorBuildingForm/AdministratorBuildingForm';

const Actions: FC = () => {
  const id = useField<number | undefined>('id').input.value;
  const dispatch = useAppDispatch();

  const { submit } = useForm();

  const saveBuilding = useCallback(async () => {
    const result = await submit();
    if (!result) throw new Error('Form is invalid');
  }, [submit]);

  const deleteBuilding = useCallback(async () => {
    if (id) await dispatch(removeBuilding(id));
  }, [dispatch, id]);

  return (
    <>
      {id && (
        <ProgressButton
          variant='outlined'
          onClick={deleteBuilding}
          data-testid='deleteBuilding'
        >
          Удалить
        </ProgressButton>
      )}
      <ProgressButton
        variant='contained'
        onClick={saveBuilding}
        data-testid='saveBuilding'
        type='submit'
      >
        {id ? 'Сохранить' : 'Создать'}
      </ProgressButton>
    </>
  );
};

export const AdministratorBuildingSidesheetPanel: FC = () => {
  return (
    <AdministratorBuildingForm>
      <Panel actions={<Actions />} testId='administratorBuildingSidesheetPanel'>
        <AdministratorBuildingFields />
      </Panel>
    </AdministratorBuildingForm>
  );
};
